var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00012207,
    y: 0.00012207,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#EB0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99988 9.75832L8.5692 12.6664L13.9999 6.66638",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingChecked);
export default __webpack_public_path__ + "static/media/onboarding_checked.3a6246745b4bcb0a112a5383d642d189.svg";
export { ForwardRef as ReactComponent };